import React from 'react';
import UICheckbox from 'Components/UIComponents/UICheckbox';
import { DocumentFieldUpdatePayload } from 'Interfaces/DocumentFields';

interface FieldCheckedByDefaultProps {
  isChecked: boolean;
  onUpdateDocumentField: (payload: Omit<DocumentFieldUpdatePayload, 'id'>) => void;
}

function FieldCheckedByDefault({
  isChecked,
  onUpdateDocumentField,
}: FieldCheckedByDefaultProps) {
  const handleCheckField = () => onUpdateDocumentField({ checked: !isChecked });

  return (
    <div className="fieldDropDown__checkbox">
      <UICheckbox
        check={isChecked}
        handleClick={handleCheckField}
        label="Checked by default"
      />
    </div>
  );
}

export default FieldCheckedByDefault;
